import React from "react";
import { useAdminPermission } from "../hooks/useAdminPermission";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import {
  AdminPermissionContext,
} from "../contexts/AdminPermissionContext";

interface ProtectedAdminPageProps {
  children: React.ReactNode;
  moduleKey: string;
}

/**
 * Wrapper que protege una página de admin verificando permisos
 * Si el usuario no tiene acceso al módulo, muestra pantalla de acceso denegado
 * Proporciona contexto con información de permisos para que el componente hijo
 * pueda ocultar botones de edición/creación si solo tiene acceso de lectura
 */
export const ProtectedAdminPage: React.FC<ProtectedAdminPageProps> = ({
  children,
  moduleKey,
}) => {
  const { hasAccess, canWrite, getPermission } = useAdminPermission();

  if (!hasAccess(moduleKey)) {
    return (
      <UnauthorizedAccess
        title="Acceso Denegado"
        description={`Tu rol no tiene permisos para acceder a esta sección. Si crees que esto es un error, contacta con el administrador.`}
      />
    );
  }

  const isReadOnly = !canWrite(moduleKey);
  const permission = getPermission(moduleKey);

  return (
    <AdminPermissionContext.Provider
      value={{
        hasAccess,
        canWrite,
        getPermission,
        moduleKey,
        isReadOnly,
      }}
    >
      {children}
    </AdminPermissionContext.Provider>
  );
};

export default ProtectedAdminPage;
